import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Chip } from '@/components/UI/Chip/Chip';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 15px 20px;
  width: 100%;
  max-width: 1000px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  margin-top: 20px;
  overflow-anchor: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 10px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 15px 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 15px;
  }
`;

export const Title = styled(Typography.Title).attrs({ $variant: '2' })`
  font-size: 20px;
  padding: 10px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 18px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 15px 10px;
  flex-wrap: wrap;
`;

export const Item = styled(Chip).attrs({ appearance: 'gray', isRounded: true })`
  padding: 15px;
  height: 40px;
`;
